import { DefaultType, Property } from 'api/clients/PropertyClient'
import { Condition } from '../../../../Filter'

import Styles from './PropertyFilter.module.scss'
import { useFilterProperties } from 'screens/Finder/components/ViewPreferences/components/ViewModifierControls/Filter/hooks/useFilterProperties'
import { usePropertyForCondition } from '../../../../hooks/usePropertyForCondition'
import { PropertyPicker } from '../../../../../common/PropertyPicker/PropertyPicker'
import { useProperties } from 'hooks/queries/companies/properties/useProperties'
import { Spinner } from 'common/Spinner/Spinner'
import { useFinderContext } from 'screens/Finder/FinderContext'
import { ViewType } from 'types'
interface Props {
  condition: Condition
  onChange: (newProperty: Property) => void
}

export const PropertyFilter = ({ condition, onChange }: Props) => {
  const property = usePropertyForCondition(condition)
  let [properties] = useFilterProperties({ excludedProperties: [DefaultType.LastOpened, DefaultType.Shared] })
  useProperties({}, { enabled: true }, { pushToStore: true })
  const { filesView } = useFinderContext()

  // If the selected property is not found in the store, go fetch it
  useProperties(undefined, { enabled: !property }, { pushToStore: true })

  if (!property) return <Spinner />

  let isDisabled = false

  if (filesView?.schema?.calendar_property_id) {
    const { calendar_property_id } = filesView.schema
    isDisabled = calendar_property_id === property.id
    properties = properties.filter(
      (p) => filesView.schema.default_view !== ViewType.Calendar || p.id !== calendar_property_id,
    )
  }

  return (
    <PropertyPicker
      selectedProperty={property}
      onPropertySelected={onChange}
      triggerClassName={Styles.trigger}
      properties={properties}
      isDisabled={!!isDisabled}
    />
  )
}
